export const RECORD = 'record'

export const ACCESS_CODES = 'access_codes'
